import {
  EXPERIENCE_TYPE_GM, BUNDLE_TYPE_COMBO, EXPERIENCE_TYPE_KITCHEN, BUNDLE_TYPE_PACKAGE, EXPERIENCE_TYPE_LAUNDRY
}
from './base-configuration';

export const UNAVAILABLE_EXPERIENCES = [
  { experienceType: EXPERIENCE_TYPE_GM, bundleType: BUNDLE_TYPE_COMBO },
  { experienceType: EXPERIENCE_TYPE_KITCHEN, bundleType: BUNDLE_TYPE_PACKAGE },
  { experienceType: EXPERIENCE_TYPE_LAUNDRY, bundleType: BUNDLE_TYPE_PACKAGE }
];